<template>
  <div v-if="!loading" class="group group--contentful group--sidebar">
    <h1 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h1">{{ title }}</h1>
    <p class="p fw-medium">{{ excerpt }}</p>

    <hr class="hr">

    <h2 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h2 mb c-mid fw-bold">Learn more</h2>

    <ul class="list list--articles mt">
      <li v-for="(article, index) in orderArticles" :key="article.id" class="list__item m0">
        <a class="link p tdn m0 df df--column" @click="navigateToArticle(article)">
          <h4 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h4 c-accent fw-bold m0">{{ article.name }}</h4>
          <span>{{ article.sub }}</span>
        </a>

        <hr v-if="index < articles.length - 1" class="hr">
      </li>
    </ul>

    <hr v-if="richText" class="hr">

    <module-rich-text
      v-if="richText"
      :entry="richText"
    />

    <hr v-if="topic.author || topic.source || topic.copyright" class="hr">

    <p
      v-if="topic.author"
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="article__author fw-bold c-accent p">{{ topic.author }}</p>
    <p v-if="topic.source" class="p">{{ topic.source }}</p>
    <p v-if="topic.copyright" class="p">{{ topic.copyright.text }}</p>

    <module-modal
      :modal="modalExternalData"
      v-show="showDisclaimer"
      @close="showDisclaimer = false"
    >

      <template slot="modal-footer">
        <module-button @click.native="showDisclaimer = false">No</module-button>
        <module-button @click.native="goToUrl">Yes</module-button>
      </template>
    </module-modal>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Utils
import { toSlug } from 'utils/string';

// Components
import ModuleRichText from 'components/RichText';
import ModuleModal from 'components/Modal';

export default {
  name: 'view-topics',

  // Components
  components: {
    ModuleRichText,
    ModuleModal,
  },

  data() {
    return {
      preUrl: null,
      showDisclaimer: false,
      modalExternalData: {
        title: 'You are now leaving the website.',
        copy: 'Your destination website is not controlled by our privacy statement. Please read the privacy statement of your destination website. Do you want to continue?',
      },
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', [
      'org',
    ]),
    ...mapGetters('contentful', ['topics', 'articles']),

    orderArticles() {
      return _.orderBy(this.articles, `order`); // eslint-disable-line
    },

    topic() {
      if ( !this.topics || !this.topics.length ) return;
      return _.find(this.topics, topic => topic.id === this.$route.query.topicId); // eslint-disable-line
    },

    title() {
      if ( !this.topic ) return;
      return this.topic.name || null;
    },

    excerpt() {
      if ( !this.topic ) return;
      return this.topic.excerpt || null;
    },

    richText() {
      if ( !this.topic ) return;
      return this.topic.richText || null;
    },

    loading() {
      return !this.topics || !this.title;
    },
  },

  watch: {
    org(org) {
      if (!org) return;
      this.requestArticles();
    },
  },

  // Methods
  methods: {
    ...mapActions('contentful', ['getArticles', 'getTopics']),

    goToUrl() {
      window.open(this.preUrl, '_blank');
      this.showDisclaimer = false;
    },

    navigateToArticle(article) {
      const { externalUrl } = article;

      if (externalUrl && this.org.show_disclaimer) {
        this.showDisclaimer = true;
        this.preUrl = externalUrl;
      } else if (externalUrl && !this.org.show_disclaimer) {
        this.preUrl = externalUrl;
        this.goToUrl();
      } else {
        this.$router.push({
          name: 'article',
          params: {
            article: toSlug(article.name),
          },
          query: {
            ...this.$route.query,
            articleId: article.id,
          },
        });
      }
    },

    requestArticles() {
      if ( this.$route.query.topicId && this.org.parent_code ) {
        this.getArticles({
          name: this.$route.query.topicId,
          parentCode: this.org.parent_code,
        });
      }
    },
  },

  // Lifecycles
  created() {
    if ( !this.$route.params.topic ) {
      this.$router.push({
        name: 'topics',
      });

      return;
    }

    this.getTopics();
    this.requestArticles();
  },
};
</script>



// WEBPACK FOOTER //
// Topic.vue?b443d3a8